// components/providers/AuthProviders.tsx
import React, { ReactNode } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthTokenProvider } from '../hooks/useAuthToken';
import { generateNonce } from '../utils/helpers';
import { logger } from '../utils/logger';

interface AuthProvidersProps {
  children: ReactNode;
}

const GoogleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';

// Debug: Log the client ID (only first/last 4 chars for security)
if (import.meta.env.DEV) {
  if (GoogleClientId) {
    logger.info(`Google Client ID loaded: ${GoogleClientId.substring(0, 4)}...${GoogleClientId.substring(GoogleClientId.length - 4)}`);
  } else {
    logger.error('VITE_GOOGLE_CLIENT_ID is not set! Check your .env file and restart Vite dev server.');
  }
}

export const AuthProviders: React.FC<AuthProvidersProps> = ({ children }) => {
  // Don't render GoogleOAuthProvider if client ID is missing
  if (!GoogleClientId) {
    logger.error('Cannot initialize Google OAuth: Missing VITE_GOOGLE_CLIENT_ID');
    return <AuthTokenProvider>{children}</AuthTokenProvider>;
  }

  return (
    <GoogleOAuthProvider
      clientId={GoogleClientId}
      nonce={generateNonce()}
      onScriptLoadSuccess={() => logger.info('Google OAuth Script Loaded Successfully!')}
      onScriptLoadError={() => logger.error('Google OAuth Script Loading Failed!')}
    >
      <AuthTokenProvider>
        {children}
      </AuthTokenProvider>
    </GoogleOAuthProvider>
  );
};